'use client';

import { useUpdateGardenSize } from '@api/gardens';
import { useGardenPlannerContext } from '@modules/garden-planner/context/garden_planner_context';
import {
  createHandleAddRow,
  createHandleConfirmedRemoveRow,
  createHandleAddColumn,
  createHandleConfirmedRemoveColumn,
  createHandleSizeChange,
  createHandleRemoveRow,
  createHandleRemoveColumn,
} from '@modules/garden-planner/sidebar/grid_controls/business_logic';
import { text as gardenPlannerText } from '@modules/garden-planner/text_business_logic';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface GridControlsContainerProps {
  views: GardenPlannerViews;
}

export function GridControlsContainer({ views }: GridControlsContainerProps) {
  const { garden, onConfirm } = useGardenPlannerContext();
  const { GridControlsView } = views;
  const updateGardenSize = useUpdateGardenSize();

  const handleAddRow = createHandleAddRow(garden, updateGardenSize);
  const handleConfirmedRemoveRow = createHandleConfirmedRemoveRow(garden, updateGardenSize);
  const handleAddColumn = createHandleAddColumn(garden, updateGardenSize);
  const handleConfirmedRemoveColumn = createHandleConfirmedRemoveColumn(garden, updateGardenSize);
  const handleSizeChange = createHandleSizeChange(garden, updateGardenSize);
  const onRemoveRow = createHandleRemoveRow(
    garden,
    handleConfirmedRemoveRow,
    onConfirm,
    gardenPlannerText.removeRowConfirmCopy
  );
  const onRemoveColumn = createHandleRemoveColumn(
    garden,
    handleConfirmedRemoveColumn,
    onConfirm,
    gardenPlannerText.removeColumnConfirmCopy
  );

  return (
    <GridControlsView
      rows={garden.rows}
      columns={garden.columns}
      onAddRow={handleAddRow}
      onRemoveRow={onRemoveRow}
      onAddColumn={handleAddColumn}
      onRemoveColumn={onRemoveColumn}
      onRowsChange={(rows) => handleSizeChange(rows, garden.columns)}
      onColumnsChange={(columns) => handleSizeChange(garden.rows, columns)}
    />
  );
}
